import {trackservice} from "@/utils/request";


// 上报埋点事件
export function addTrackInfo(data) {
    return trackservice({
        url: "/bswjjc/api/pri/user/behavior",
        method: "POST",
        data,
    });
}
